import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: 0
}

export const searchDrawerTabSlice = createSlice({
  name: 'searchDrawerTab',
  initialState,
  reducers: {
    setTab: (state, action) => {
      return {
        ...state,
        id: action.payload.id
      }
    },
  }
})

export const { setTab } = searchDrawerTabSlice.actions

export default searchDrawerTabSlice.reducer